import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=27b209b2&scoped=true&functional=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=27b209b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "27b209b2",
  null
  
)

export default component.exports